import "./App.css";
import React from "react";
import { Routes, Route, HashRouter } from "react-router-dom";
import IntroContainer from "./pages/containers/IntroContainer";
import MobileIntroContainer from "./pages/containers/MobileIntroContainer";

function App() {
  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<IntroContainer />} />
        <Route path="/m/*" element={<MobileIntroContainer />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
